import { formatDateTime as formatSwissDateTime } from '@agentselly/ui';

/**
 * Datum mit Uhrzeit als TT.MM.JJJJ, hh:mm. Dünne Hülle um den geteilten
 * Formatter aus `@agentselly/ui` (AGE-162).
 *
 * Unterschied zum geteilten Formatter: fehlende oder ungültige Daten ergeben
 * hier den Leerstring statt `—`, weil die Aufrufer darauf bedingt rendern.
 */
export function formatDateTime(dateString: any): string {
  return formatSwissDateTime(dateString, { fallback: '' });
}
